import sendUserAddedToTeamEmail from './send-user-added-to-team-email';

export { default as sendUserAddedToTeamEmail } from './send-user-added-to-team-email';

export default {
  sendUserAddedToTeamEmail,
};
